const napisy = {
    name: 'napis-na-pierwszym-zdjeciu',
    names: [
        'napis_4x4',
        'napis_aukcja',
        'napis_automat',
        'napis_bezwypadkowy',
        'napis_cesja_leasingu',
        'napis_faktura_vat',
        'napis_gwarancja',
        'napis_klimatyzacja',
        'napis_okazja',
        'napis_pierwszy_właściciel',
        'napis_rezerwacja',
        'napis_salon_polska'
    ],
    onlyOne: true,
    options: [
        '4x4',
        'Aukcja',
        'Automat',
        'Bezwypadkowy',
        'Cesja leasingu',
        'Faktura VAT',
        'Gwarancja',
        'Klimatyzacja',
        'Okazja',
        'Pierwszy właściciel',
        'Rezerwacja',
        'Salon Polska',
    ],
}

// napisy (nazwy pól i etykiety) — formularz (src/components/add/form2/InscriptionField.js) i wyświetlanie
export { napisy as INSCRIPTIONS }

// Etykieta napisu do wyświetlenia: zapis to nazwa pola bez „napis_” (np. „salon polska”); wartość spoza listy — bez zmian.
const key = (value) => String(value).trim().toLowerCase().replace(/[\s_]+/g, ' ')
const LABELS = new Map(napisy.options.map((label) => [key(label), label]))
export function inscriptionLabel (value) {
    if (typeof value !== 'string' || !value.trim()) return ''
    return LABELS.get(key(value)) || value.trim()
}
